import ReactModal from 'react-modal';
import { RoleTag } from '../pages/person/RoleTag';
import General from '../utils/GeneralUtils';
import './EmailVerificationSlideout.scss';
import './FunctionalGroupSlideout.scss';

const FUNCTIONAL_GROUPS = [
  {
    value: 'district administration',
    label: 'District Administration',
    color: 'orange',
    description: 'Central office functions including executive leadership, communications, and board relations.',
    examples: 'Superintendent, Board Secretary, Communications Director',
  },
  {
    value: 'finance and procurement',
    label: 'Finance and Procurement',
    color: 'yellow',
    description: 'Budget, accounting, purchasing, and financial management functions.',
    examples: 'CFO, Business Manager, Purchasing Director, Accountant',
  },
  {
    value: 'human resources',
    label: 'Human Resources',
    color: 'green',
    description: 'Staffing, benefits, employee relations, and workforce management.',
    examples: 'HR Director, Benefits Coordinator, Recruiter',
  },
  {
    value: 'technology',
    label: 'Technology',
    color: 'blue',
    description: 'IT infrastructure, educational technology, and digital systems.',
    examples: 'CTO, IT Director, Network Administrator, EdTech Specialist',
  },
  {
    value: 'operations',
    label: 'Operations',
    color: 'teal',
    description: 'Facilities, transportation, food service, and safety functions.',
    examples: 'COO, Facilities Director, Transportation Director, Food Service Manager',
  },
  {
    value: 'curriculum and instruction',
    label: 'Curriculum and Instruction',
    color: 'purple',
    description: 'Academic programs, teaching standards, and instructional support.',
    examples: 'Curriculum Director, Instructional Coach, Department Chair',
  },
  {
    value: 'special education',
    label: 'Special Education',
    color: 'pink',
    description: 'Services for students with disabilities and special learning needs.',
    examples: 'Special Ed Director, SPED Teacher, School Psychologist',
  },
  {
    value: 'student services',
    label: 'Student Services',
    color: 'cyan',
    description: 'Counseling, social work, health services, and student support programs.',
    examples: 'Counselor, Social Worker, School Nurse, Student Success Coach',
  },
];

interface FunctionalGroupSlideoutProps {
  isOpen: boolean;
  onClose: () => void;
}

export function FunctionalGroupSlideout({ isOpen, onClose }: FunctionalGroupSlideoutProps) {
  return (
    <ReactModal
      isOpen={isOpen}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      onRequestClose={onClose}
      style={General.getSliderDefaults({ width: 'min(90vw, 450px)' })}
      parentSelector={General.getModalRoot}
    >
      <div className="email-verification-slideout">
        <div className="header">
          <h3>Functional Group</h3>
        </div>

        <div className="section intro">
          <p>Functional Group categorizes roles by the department or area of responsibility within the organization.</p>
        </div>

        <div className="section">
          <div className="functional-group-list">
            {FUNCTIONAL_GROUPS.map((group) => (
              <div key={group.value} className="functional-group-item">
                <RoleTag type="functionalGroup" value={group.label} size="small" />
                <p className="functional-group-item__description">{group.description}</p>
                <p className="desc-2" style={{ marginTop: 0 }}>e.g., {group.examples}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </ReactModal>
  );
}
